<template>
  <!--    客戶-->
  <div>
    <div :class="{ blur: addFlag }">
      <vs-row vs-type="flex" vs-align="center">
        <vs-col vs-w="6">
          <span :class="isMobile() ? 'titleMob' : 'title'">{{
            $t("message.customer")
          }}</span>
        </vs-col>
        <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end">
          <vs-button
            size="small"
            color="rgb(37, 105, 193)"
            type="border"
            style="border-radius: 15px;"
            @click="handleMethods('addFlag')"
          >
            + {{ $t("message.addCustomer") }}
          </vs-button>
        </vs-col>
      </vs-row>

      <!-- Search Bar -->
      <vs-row class="search-section" vs-type="flex" vs-align="center">
        <vs-col :vs-w="isMobile() ? '12' : '6'">
          <vs-input
            :placeholder="$t('message.searchCustomer')"
            v-model="searchQuery"
            icon="search"
            icon-pack="feather"
            class="search-input"
          />
        </vs-col>
        <vs-col
          v-if="searchQuery"
          :vs-w="isMobile() ? '12' : '6'"
          vs-type="flex"
          :vs-justify="isMobile() ? 'center' : 'flex-start'"
        >
          <vs-button
            size="small"
            color="danger"
            type="border"
            @click="clearSearch"
            style="margin-left: 10px;"
          >
            {{ $t("message.clearSearch") }}
          </vs-button>
        </vs-col>
      </vs-row>

      <vs-table :data="filteredUser" stripe pagination maxItems="15">
        <template slot="thead">
          <vs-th>
            {{ $t("message.customerCode") }}
          </vs-th>
          <vs-th>
            {{ $t("message.name") }}
          </vs-th>
          <vs-th>
            {{ $t("message.gender") }}
          </vs-th>
          <vs-th>
            {{ $t("message.username") }}
          </vs-th>
          <vs-th>
            {{ $t("message.email") }}
          </vs-th>
          <vs-th>
            {{ $t("message.phone") }}
          </vs-th>
          <vs-th>
            {{ $t("message.createdAt") }}
          </vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td
              :data="data[indextr].customer[0].code"
              v-if="data[indextr].customer[0]"
            >
              {{ data[indextr].customer[0].code }}
            </vs-td>
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td
              :data="data[indextr].customer[0].gender"
              v-if="data[indextr].customer[0]"
            >
              {{ $t(`message.${data[indextr].customer[0].gender}`) }}
            </vs-td>
            <vs-td :data="data[indextr].username">
              {{ data[indextr].username }}
            </vs-td>
            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>

            <vs-td :data="data[indextr].phone">
              {{ data[indextr].phone }}
            </vs-td>

            <vs-td :data="data[indextr].createdAt">
              {{ data[indextr].createdAt | timeFormat }}
            </vs-td>
            <vs-td style="white-space: nowrap">
              <vs-button
                size="small"
                color="danger"
                type="border"
                @click="onResetPwd('reset', tr)"
                class="m-r"
                >{{ $t("message.resetPwd") }}</vs-button
              >
              <vs-button
                size="small"
                color="rgb(37, 105, 193)"
                @click="onDetail(tr.customer[0]._id)"
                >{{ $t("message.details") }}</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <vs-popup :active.sync="addFlag" title=" ">
      <div class="card-title">
        {{ $t("message.newCustomer") }}
      </div>
      <vs-row class="m-t-1">
        <vs-col vs-w="6">
          <vs-select
            v-model="customer.agent"
            autocomplete
            :placeholder="$t('message.agent')"
            style="width: 100%"
            multiple
          >
            <vs-select-item
              :key="index"
              :value="item._id"
              :text="`${item.name} (${item.agentNumber})`"
              v-for="(item, index) in agent"
              aria-multiselectable="true"
            />
          </vs-select>
        </vs-col>
      </vs-row>
      <vs-row class="m-t-1">
        <vs-col vs-w="6">
          <vs-input
            v-model="customer.username"
            :placeholder="$t('message.username')"
            style="width: 100%"
          ></vs-input>
        </vs-col>
      </vs-row>
      <vs-row class="m-t-1">
        <vs-col vs-w="6">
          <vs-input
            v-model="customer.name"
            :placeholder="$t('message.name')"
            style="width: 100%"
          ></vs-input>
        </vs-col>
        <vs-col vs-w="6">
          <vs-input
            v-model="customer.code"
            :placeholder="$t('message.customerCode') + ' (e.g. C0000001)'"
            style="width: 100%"
          ></vs-input>
        </vs-col>
      </vs-row>
      <vs-row class="m-t-1">
        <vs-col vs-w="6">
          <vs-select
            v-model="customer.gender"
            autocomplete
            :placeholder="$t('message.gender')"
            style="width: 100%"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in genderOpt"
            />
          </vs-select>
        </vs-col>
        <vs-col vs-w="6">
          <vs-input
            v-model="customer.phone"
            :placeholder="$t('message.phone')"
            style="width: 100%"
          ></vs-input>
        </vs-col>
      </vs-row>
      <vs-row class="m-t-1">
        <vs-col vs-w="6">
          <vs-input
            v-model="customer.email"
            :placeholder="$t('message.email')"
            style="width: 100%"
          ></vs-input>
        </vs-col>
        <vs-col vs-w="6">
          <datepicker
            class="fixedPicker"
            v-model="customer.dateOfBirth"
            :placeholder="$t('message.dateOfBirth')"
            :format="format"
            :highlighted="highlight"
          ></datepicker>
        </vs-col>
      </vs-row>
      <vs-row class="m-t-1">
        <vs-col vs-w="6">
          <vs-input
            v-model="customer.residenceAddress"
            :placeholder="$t('message.residentialAddress')"
            style="width: 100%"
          ></vs-input>
        </vs-col>
        <vs-col vs-w="6">
          <vs-input
            v-model="customer.correspondenceAddress"
            :placeholder="$t('message.corrAddress')"
            style="width: 100%"
          ></vs-input>
        </vs-col>
      </vs-row>
      <vs-row class="m-t-3">
        <vs-col vs-w="12" vs-type="flex" vs-align="center">
          <span style="font-size: 18px;margin-right: 15px;color: #626262">{{
            $t("message.plan")
          }}</span>
          <vs-button
            size="small"
            color="rgb(37, 105, 193)"
            class="stribtn"
            @click="handleMethods('addPlan')"
            >+ {{ $t("message.plan") }}</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-row class="m-t-1">
        <vs-col
          vs-w="12"
          style="width: 100%"
          v-if="customer.plans[0]"
          class="scrollTable"
        >
          <vs-table
            :data="customer.plans"
            stripe
            noDataText="No Plan"
            style="overflow: scroll"
          >
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th>
                <span style="color:#959595">{{
                  $t("message.subscriptedPlan")
                }}</span>
              </vs-th>
              <vs-th>
                {{ $t("message.currency") }}
              </vs-th>
              <vs-th>
                {{ $t("message.validDate") }}
              </vs-th>
              <vs-th>
                {{ $t("message.expiryDate") }}
              </vs-th>
              <vs-th>
                {{ $t("message.balanceAmount") }}
              </vs-th>
              <vs-th>
                {{ $t("message.expectedAnnualReturn") }}
              </vs-th>
              <vs-th>
                {{ $t("message.actualAnnualReturn") }}
              </vs-th>
              <vs-th>
                {{ $t("message.beneficiary") }}
              </vs-th>
              <vs-th>
                {{ $t("message.beneficiaryDeath") }}
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <vs-button
                    size="small"
                    color="danger"
                    type="border"
                    icon="remove"
                    @click="customer.plans.splice(indextr, 1)"
                  ></vs-button>
                </vs-td>
                <vs-td :data="data[indextr].name">
                  <span style="color: #909090">{{
                    lang == "en" ? data[indextr].name : data[indextr].name_zh
                  }}</span>
                </vs-td>

                <vs-td :data="data[indextr].currency">
                  {{ data[indextr].currency }}
                </vs-td>

                <vs-td :data="data[indextr].effectiveDate">
                  {{ data[indextr].effectiveDate | dateFormat }}
                </vs-td>
                <vs-td :data="data[indextr].expiryDate">
                  {{ data[indextr].expiryDate | dateFormat }}
                </vs-td>
                <vs-td :data="data[indextr].amount">
                  {{ data[indextr].amount }}
                </vs-td>
                <vs-td :data="data[indextr].expectedAnnualReturn">
                  {{ data[indextr].expectedAnnualReturn }}
                </vs-td>
                <vs-td :data="data[indextr].actualAnnualReturn">
                  {{ data[indextr].actualAnnualReturn }}
                </vs-td>
                <vs-td :data="data[indextr].beneficiaries">
                  <div v-if="tr.beneficiaries && tr.beneficiaries[0]">
                    {{ data[indextr].beneficiaries.join(", ").tran() }}
                  </div>
                  <div v-else>
                    {{ data[indextr].beneficiary.tran() }}
                  </div>
                </vs-td>
                <vs-td :data="data[indextr].beneficiariesAfterDeath">
                  <div
                    v-if="
                      tr.beneficiariesAfterDeath &&
                        tr.beneficiariesAfterDeath[0]
                    "
                  >
                    {{
                      data[indextr].beneficiariesAfterDeath.join(", ").tran()
                    }}
                  </div>
                  <div v-else>
                    {{ data[indextr].beneficiaryAfterDeath.tran() }}
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-col>
        <vs-col vs-w="12" v-else>
          <textarea name="plan" id="plan" disabled></textarea>
        </vs-col>
      </vs-row>
      <vs-row class="m-t-2">
        <vs-col vs-w="12" vs-type="flex" vs-justify="center">
          <vs-button
            size="small"
            color="rgb(37, 105, 193)"
            class="stribtn"
            @click="onCreateCustomer()"
            >{{ $t("message.add") }}</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-popup :active.sync="addPlanFlag" title=" ">
        <EditPlan
          type="add"
          :data.sync="newPlan"
          @add="addPlan"
          :uploading.sync="uploading"
          @upload="uploadDocs"
        />
      </vs-popup>
    </vs-popup>

    <vs-popup :active.sync="resetFlag" title=" ">
      <div class="card-title m-t-1">
        您确定重设 {{ currentUser.username }} 的密码吗？
      </div>

      <vs-row class="m-t-3">
        <vs-col vs-w="12" vs-type="flex" vs-justify="center">
          <vs-button
            size="small"
            color="rgb(37, 105, 193)"
            @click="onResetPwd('confirm')"
            class="stribtn m-r-1"
            >{{ $t("message.confirm") }}</vs-button
          >
          <vs-button size="small" color="danger" class="stribtn">{{
            $t("message.cancel")
          }}</vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import EditPlan from "@/components/EditPlan";

export default {
  beforeRouteEnter(to, from, next) {
    if (
      $cookies.get("role") === "admin" ||
      $cookies.get("role") === "manager"
    ) {
      next();
    } else if ($cookies.get("role") === "user") {
      next("/");
    } else if ($cookies.get("role") === "agent") {
      next("/customer");
    }
  },
  data() {
    return {
      token: "",
      lang: "",
      format: "dd / MM / yyyy",
      highlight: {
        customPredictor(date) {
          if (
            date.getDate() - new Date().getDate() == 0 &&
            date.getMonth() - new Date().getMonth() == 0
          )
            return true;
        },
      },

      user: [],
      agent: [],
      searchQuery: "",
      updateFlag: false,
      currentUser: {
        username: "",
        phone: "",
        email: "",
        profilePic: "",
        _id: "",
      },
      addFlag: false,
      addPlanFlag: false,
      genderOpt: [
        { value: "male", text: this.$t("message.male") },
        { value: "female", text: this.$t("message.female") },
      ],
      customer: {
        agent: [],
        username: "",
        name: "",
        email: "",
        phone: "",
        code: "",
        gender: "",
        dateOfBirth: "",
        residenceAddress: "",
        correspondenceAddress: "",
        plans: [],
      },
      newPlan: {
        name: "",
        name_zh: "",
        currency: "USD",
        effectiveDate: "",
        expiryDate: "",
        amount: "",
        expectedAnnualReturn: "",
        actualAnnualReturn: "",
        beneficiaries: [],
        beneficiariesAfterDeath: [],
        totalNetContributionSinceEffectiveDate: "",
        totalTransferAsset: "",
        totalTransferOutAsset: "",
        investmentBalanceSinceEffectiveDate: "",
        balance: "",
        return: "",
        quarterlyFundOverview: "",
        dividendMode: "",
      },
      uploading: false,
      resetFlag: false,
    };
  },
  created() {
    this.token = this.$cookies.get("token");
    this.$vs.loading({
      type: "point",
    });
    this.lang = this.$cookies.get("lang");

    let url =
      process.env.VUE_APP_API_BASEURL +
      "/api/user?role[]=user&status=normal&access_token=" +
      this.$cookies.get("token");
    let aurl =
      process.env.VUE_APP_API_BASEURL +
      "/api/user?role[]=agent&status=normal&access_token=" +
      this.$cookies.get("token");
    fetch(aurl)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.agent = data.responseDetail.data;
      });
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.user = data.responseDetail.data;
        if (data) {
          this.$vs.loading.close();
        }
      });
  },
  computed: {
    filteredUser() {
      if (!this.searchQuery) {
        return this.user;
      }

      const query = this.searchQuery.toLowerCase().trim();

      return this.user.filter((item) => {
        // Search by customer code
        const code =
          item.customer && item.customer[0] && item.customer[0].code
            ? item.customer[0].code.toLowerCase()
            : "";

        // Search by name
        const name = item.name ? item.name.toLowerCase() : "";

        // Search by username
        const username = item.username ? item.username.toLowerCase() : "";

        // Search by email
        const email = item.email ? item.email.toLowerCase() : "";

        // Search by phone
        const phone = item.phone ? item.phone.toLowerCase() : "";

        return (
          code.includes(query) ||
          name.includes(query) ||
          username.includes(query) ||
          email.includes(query) ||
          phone.includes(query)
        );
      });
    },
  },
  methods: {
    onReload() {
      let url =
        process.env.VUE_APP_API_BASEURL +
        "/api/user?role[]=user&status=normal&access_token=" +
        this.$cookies.get("token");
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.user = data.responseDetail.data;
          if (data) {
            this.$vs.loading.close();
          }
        });
    },
    onDetail(id) {
      this.$router.push({
        name: "customerDetail",
        params: {
          id: id,
        },
      });
    },
    clearSearch() {
      this.searchQuery = "";
    },
    handleMethods(type) {
      switch (type) {
        case "addFlag": {
          this.customer = {
            agent: "",
            username: "",
            name: "",
            email: "",
            phone: "",
            code: "",
            gender: "",
            dateOfBirth: "",
            residenceAddress: "",
            correspondenceAddress: "",
            plans: [],
          };
          this.addFlag = true;
          break;
        }
        case "addPlan": {
          this.newPlan = {
            name: "",
            name_zh: "",
            currency: "HKD",
            effectiveDate: "",
            expiryDate: "",
            amount: "",
            expectedAnnualReturn: "",
            actualAnnualReturn: "",
            beneficiaries: [],
            beneficiariesAfterDeath: [],
            totalNetContributionSinceEffectiveDate: "",
            totalTransferAsset: "",
            totalTransferOutAsset: "",
            investmentBalanceSinceEffectiveDate: "",
            balance: "",
            return: "",
            quarterlyFundOverview: "",
            dividendMode: "",
            planTemplate: "",
          };
          this.addPlanFlag = true;
          break;
        }
      }
    },
    uploadDocs(e) {
      this.uploading = true;
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      let url =
        process.env.VUE_APP_API_BASEURL +
        "/api/attachment/upload?access_token=" +
        this.token;
      fetch(url, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.log(error);
        })
        .then((result) => {
          this.newPlan.quarterlyFundOverview = result.responseDetail._id;
          if (result) {
            this.uploading = false;
          }
        });
    },
    addPlan() {
      this.addPlanFlag = false;
      this.customer.plans.push(this.newPlan);
    },
    onCreateCustomer() {
      let url =
        process.env.VUE_APP_API_BASEURL +
        "/api/customer?access_token=" +
        this.token;
      const {
        agent,
        username,
        name,
        email,
        phone,
        code,
        gender,
        dateOfBirth,
        residenceAddress,
        correspondenceAddress,
        plans,
      } = this.customer;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          agent,
          username,
          name,
          email,
          phone,
          code,
          gender,
          dateOfBirth,
          residenceAddress,
          correspondenceAddress,
          plans,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.log(error);
        })
        .then((result) => {
          console.log(result);
          if (result.responseCode === 200) {
            this.$vs.notify({
              title: "提示",
              text:
                this.$t("message.checkEmail2") +
                this.customer.email +
                this.$t("message.checkEmail3"),
              icon: "done",
              color: "success",
              position: "top-center",
              time: 3000,
            });
            this.addFlag = false;
            this.onReload();
          } else {
            this.$vs.notify({
              title: "提示",
              text: this.$t("message.errorMsg"),
              icon: "clear",
              color: "danger",
              position: "top-center",
              time: 3000,
            });
          }
        });
    },
    onDeleteUser() {
      let url =
        process.env.VUE_APP_API_BASEURL +
        "/api/user/delete/" +
        this.currentUser._id +
        "?access_token=" +
        this.token;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.log(error);
        })
        .then((result) => {
          if (result.responseCode === 200) {
            this.updateFlag = false;
            this.onReload();
          } else {
            this.$vs.notify({
              title: "提示",
              text: this.$t("message.errorDel"),
              icon: "clear",
              color: "danger",
              position: "top-center",
              time: 3000,
            });
          }
        });
    },
    onResetPwd(type, item) {
      switch (type) {
        case "reset": {
          this.currentUser.username = item.username;
          this.currentUser.email = item.email;
          this.resetFlag = true;
          break;
        }
        case "confirm": {
          let url = process.env.VUE_APP_API_BASEURL + "/api/auth/forget";
          fetch(url, {
            method: "post",
            headers: {
              Accept: "application/json, text/plain, */*",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: this.currentUser.email,
            }),
          })
            .then((response) => {
              return response.json();
            })
            .then((res) => {
              if (res.responseCode === 200) {
                this.$vs.notify({
                  title: "提示",
                  text:
                    this.$t("message.checkEmail4") +
                    this.currentUser.email +
                    this.$t("message.checkEmail3"),
                  icon: "done",
                  color: "success",
                  position: "top-center",
                  time: 3000,
                });
              } else {
                this.$vs.notify({
                  title: "提示",
                  text: this.$t("message.errorMsg"),
                  icon: "clear",
                  color: "danger",
                  position: "top-center",
                  time: 3000,
                });
              }
              this.resetFlag = false;
            });
          break;
        }
      }
    },
  },
  components: {
    Datepicker,
    EditPlan,
  },
  filters: {
    numberFormat(val) {
      return val.toLocaleString();
    },
  },
};
</script>
<style>
.scrollTable .vs-table--content {
  width: 1000px;
}
</style>
<style scoped>
@import "../../assets/css/alert.css";

.search-section {
  margin-top: 20px;
  margin-bottom: 10px;
}

.search-input {
  width: 100%;
}

.tags {
  background: #f3ca8e;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 10px;
}

@media screen and (max-width: 400px) {
  .search-section {
    margin-top: 15px;
    margin-bottom: 10px;
  }
}
</style>
